const atcObserver = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      const target = entry.target.closest('.product-wrapper').querySelector('.sticky-atc');
      if (target !== null) {
        entry.isIntersecting ? target.classList.remove('active') : target.classList.add('active');
      }
    });
  },
  {
    threshold: 0.25,
  }
);

atcObserver.observe(document.querySelector('#AddToCartButton'));
document.querySelector('.sticky-atc')?.addEventListener('click', () => {
  document.querySelector('.product-form').scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
});

if (document.querySelector('.gallery-zoom')) {
  const zoomContainer = document.querySelector('.gallery-zoom');
  const closeBtn = zoomContainer.querySelector('.gallery-zoom__close');

  const thumbnails = Array.from(zoomContainer.querySelectorAll('.gallery-zoom__thumb-link'));
  const images = Array.from(zoomContainer.querySelectorAll('.zoomable-image'));

  let scrollTrackingInitialized = false;

  function updateActiveThumbnail(index) {
    thumbnails.forEach((thumb) => {
      thumb.classList.toggle('active', thumb.dataset.index === String(index));
    });
  }

  function initScrollTracking(container) {
    if (scrollTrackingInitialized) return;
    scrollTrackingInitialized = true;

    container.addEventListener('scroll', () => {
      let closestImage = null;
      let minDistance = Infinity;

      images.forEach((img) => {
        const imgRect = img.getBoundingClientRect();
        const containerRect = container.getBoundingClientRect();
        const distance = Math.abs(imgRect.top - containerRect.top);

        if (distance < minDistance) {
          minDistance = distance;
          closestImage = img;
        }
      });

      if (closestImage) {
        const index = closestImage.dataset.index;
        updateActiveThumbnail(index);
      }
    });
  }

  document.querySelectorAll('.product__media-item:not(.media-video)').forEach((item) => {
    item.addEventListener('click', function () {
      document.body.classList.add('drawer--open');
      zoomContainer.classList.add('gallery-zoom--active');

      const index = [...item.parentElement.children].indexOf(item) + 1;
      const target = zoomContainer.querySelector(`#zoom-image-${index}`);
      if (target) {
        target.scrollIntoView({ behavior: 'smooth' });
        updateActiveThumbnail(index);
      }

      setTimeout(() => {
        initScrollTracking(zoomContainer);
      }, 10);
    });
  });

  closeBtn.addEventListener('click', function () {
    document.body.classList.remove('drawer--open');
    zoomContainer.classList.remove('gallery-zoom--active');
  });

  zoomContainer.addEventListener('click', function (e) {
    if (e.target.classList.contains('zoomable-image')) {
      e.target.classList.toggle('zoomed');
    }
  });

  thumbnails.forEach((thumb) => {
    thumb.addEventListener('click', function (e) {
      e.preventDefault();
      const index = parseInt(this.dataset.index, 10);
      const target = zoomContainer.querySelector(`#zoom-image-${index}`);
      if (target) {
        target.scrollIntoView({ behavior: 'smooth' });
        updateActiveThumbnail(index);
      }
    });
  });
}
